import { Section } from "../components/Section.js";
import { ABOUT_BODY, ABOUT_HEADING } from "../content/site-content.js";

/**
 * About section (Req 1.2). Copy is placeholder until owner-managed content is
 * wired in.
 */
export function About(): JSX.Element {
  return (
    <Section id="about" title={ABOUT_HEADING}>
      <div className="about__body">
        {ABOUT_BODY.map((paragraph, index) => (
          <p key={index} className="about__paragraph">
            {paragraph}
          </p>
        ))}
      </div>
    </Section>
  );
}
